import {Box, FormControl, InputLabel, MenuItem, Typography} from "@mui/material";
import Select, {SelectChangeEvent} from '@mui/material/Select';
import React, {useState} from "react";
import View from "../../components/View";
import Page from "../../components/Page";
import formulas from "../../services/formulas";

const EAD = () => {

    const {calcEad} = formulas();
    const [ead, setEad] = useState(27);
    const [ean, setEan] = useState(32);
    const [depth, setDepth] = useState(32);

    const changeEan = (event: SelectChangeEvent) => {
        const eanInt = parseInt(event.target.value);
        setEan(eanInt)
        setEad(calcEad(eanInt, depth))
    }

    const changeDepth = (event: SelectChangeEvent) => {
        const depthInt = parseInt(event.target.value);
        setDepth(depthInt)
        setEad(calcEad(ean, depthInt));
    }

    // @ts-ignore
    return (
        <Page>
            <View>
                <Typography variant="h6" sx={{mt:1, mb:1}}>Equivalent Air Depth</Typography>
                <Typography variant="h6"><Box component="span" sx={{border: '1px solid grey', p: 1}}>{ead.toFixed(0)}</Box> Meters</Typography>
                <FormControl variant="standard" sx={{m: 2, minWidth: 90}}>
                    <InputLabel id="EAN">EAN</InputLabel>
                    <Select
                        labelId="EAN"
                        id="ean"
                        value={ean.toString()}
                        label="EAN"
                        onChange={changeEan}
                    >
                        {[...Array(20)].map((x, i) => (
                            <MenuItem key={'ean' + x} value={21 + i}>{21 + i}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl variant="standard" sx={{m: 2, minWidth: 90}}>
                    <InputLabel id="depth">Depth</InputLabel>
                    <Select
                        labelId="depth"
                        id="depth"
                        value={depth.toString()}
                        label="Depth"
                        onChange={changeDepth}
                    >
                        {[...Array(40)].map((x, i: number) => (
                            <MenuItem key={'depth' + x} value={1 + i}>{1 + i}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </View>
            <View>
                <Typography style={{fontWeight: 'bold'}}>Equivalent Air Depth (EAD)</Typography>
                <Typography style={{marginTop: 10}}>
                    Is a way of approximating the decompression requirements of breathing gas mixtures
                    that contain nitrogen and oxygen in different proportions to those in air.</Typography>
            </View>
        </Page>
    );
}

export default EAD;